export type CmsImageCategory = 'channel-logo' | 'channel-logo-desc' | 'device' | 'brand';

const CMS_IMAGE_BASE_URL = 'https://www.novusnow.ca/wp-content/themes/novus/images/cpq';

const getBaseUrl = (): string =>
  (import.meta.env.VITE_CMS_IMAGE_BASE_URL ?? CMS_IMAGE_BASE_URL).replace(/\/+$/, '');

export const getCmsImageUrl = (
  category: CmsImageCategory,
  code: string | undefined | null,
): string | undefined => {
  if (!code) return undefined;
  const base = getBaseUrl();
  if (!base) return undefined;
  return `${base}/${category}/${code}.png`;
};
